import { cloneDeep } from 'lodash/lang'
import { selectRedeemablePass } from 'lib/cart/services/selection'

const addGuestPass = (state, action) => {
  const { camper, redeemablePass } = action

  // clone cart products so we don't mutate state
  const cartForm = cloneDeep(state)

  // add or update a cart product for this pass
  selectRedeemablePass(redeemablePass, {
    camper,
    cartForm
  })

  // return a new state object
  return Object.assign({}, state, cartForm)
}

export default addGuestPass
